import { ContactForm } from "components/forms/ContactForm"
import "./ContactPage.scss"

export const ContactPage = () => {
    return (
        <div className="contact">
            <h1 className="contact__title">Send me a message</h1>
            <div className="contact__container">
                <div className="contact__details">
                    <p className="contact__text">
                        Please feel free to contact me.
                    </p>
                    <p className="contact__text">I will get back to you as soon as I can.</p>
                    <p className="contact__text">
                        <span>(or you can write me an email to: </span>
                        <a
                            href="mailto:amcocarojas@gmail.com"
                        >amcocarojas@gmail.com</a>
                        <span> )</span>
                    </p>
                </div>
                <ContactForm />
            </div>
        </div>
    )
}